var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFeedbackicon = function SvgFeedbackicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipPath: "url(#feedback_icon_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.303 5.983a1.211 1.211 0 0 0 .908.41H4.02l-.158 1.049C3.667 8.729 4.49 9.017 4.925 9a.52.52 0 0 0 .464-.287l1.587-3.174V0H1.611A1.211 1.211 0 0 0 .41 1.062L.01 5.03a1.211 1.211 0 0 0 .293.952ZM8.014 0v5.538h1.04a.865.865 0 0 0 .864-.865V.866A.865.865 0 0 0 9.053 0H8.014Z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.698 10.018a1.211 1.211 0 0 0-.909-.41h-2.808l.158-1.05c.195-1.287-.628-1.574-1.063-1.557a.52.52 0 0 0-.465.287L9.024 10.46v5.54h5.365a1.211 1.211 0 0 0 1.202-1.062l.4-3.97a1.21 1.21 0 0 0-.293-.951ZM7.986 16v-5.538H6.947a.865.865 0 0 0-.865.866v3.807a.865.865 0 0 0 .865.865h1.04Z",
    opacity: 0.9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "feedback_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgFeedbackicon;